// extracted by mini-css-extract-plugin
export default {"container":"CheckBox_container__J5F9A"};